



// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Link } from 'react-router-dom';

// const HomePolitics = (props) => {
//     const homePolitics = props.data || [];
//     console.log("homePolitics---", homePolitics);
//     const [data, setData] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     // Define default static data matching the backend structure
//     const defaultData = {
//         main_news: {
//             featured: {
//                 title: "राजनीति की ताज़ा खबरें",
//                 category: "यमुनोत्री जाते समय चलती कार में गिरा पहाड़: 3 लोग सवार, बिहार से आए दर्शन करने; रेस्क्यू ऑपरेशन जारी – Uttarkashi News",
//                 date: "2017-03-22T17:49",
//                 image: "/assets/img/ezgif-5530dd1da8b37c_1759988348.webp"
//             },
//             list: [
//                 {
//                     title: "जहरीला कफ सिरप बनाने वाली कंपनी का डायरेक्टर गिरफ्तार:– Madhya Pradesh",
//                     image: "/assets/img/live-update-centre-2025-10-09t081936484_1759978108.webp",
//                     category: "News",
//                     date: "2017-03-22T17:50",
//                     description: "मध्य प्रदेश में 23 बच्चों की मौत का कारण बने कोल्ड्रिफ कफ सिरप बनाने वाली कंपनी श्रीसन फार्मा का डायरेक्टर गोविंदन रंगनाथन गिरफ्तार कर लिया गया है। मामले में मध्य प्रदेश सरकार द्वारा बनाई गई SIT की टीम ने बुधवार-गुरुवार की दरमियानी रात तमिलनाडु के...."
//                 },
//                 {
//                     title: "हरियाणा IPS सुसाइड केस; 2 धड़ों में बंटे अफसर:– Chandigarh News",
//                     image: "/assets/img/ezgif-25eec5267e400a_1759978236.webp",
//                     category: "News",
//                     date: "2017-03-22T02:34",
//                     description: "हरियाणा के IPS अफसर IG वाई पूरन कुमार का सुसाइड केस अब तूल पकड़ता दिख रहा है। इस मामले में IPS-IAS अफसरों के साथ ही HCS और HPS अफसर भी दो धड़ों में बंटे हैं। एससी वर्ग के अफसर वाई पूरन कुमार को न्याय दिलाने के लिए लामबंद हो रहे हैं।....."
//                 },
//                 {
//                     title: "नागपुर से मिला था छिंदवाड़ा को ‘मौत का अलर्ट:– Madhya Pradesh News",
//                     image: "/assets/img/11-1_1759952360.webp",
//                     category: "News",
//                     date: "2017-03-22T02:34",
//                     description: "छिंदवाड़ा में कोल्ड्रिफ कफ सिरप से हुई बच्चों की मौतों को टाला जा सकता था, यदि जिला प्रशासन नागपुर से मिले अलर्ट को सीरियसली लेता। दरअसल, नागपुर के कलर्स अस्पताल के संचालक डॉ. राजेश अग्रवाल ने 15 सितंबर को ही परासिया के स्थानीय पार्षद अनुज पाटकर को....."
//                 }
//             ]
//         },
//         sidebar: {
//             social_links: [
//                 { platform: "facebook", icon: "fa fa-facebook", follows: "50k" },
//                 { platform: "instagram", icon: "fa fa-instagram", follows: "10k" },
//                 { platform: "youtube", icon: "fa fa-youtube", follows: "25k" },
//                 { platform: "twitter", icon: "fa fa-twitter", follows: "20k" }
//             ],
//             weather: {
//                 location: "Panna, IN",
//                 time: "6:03 pm, Oct 7, 2025",
//                 temperature: "42",
//                 condition: "hello",
//                 image: "/assets/img/rain-6243559_1280.jpg"
//             },
//             recent_news: [
//                 { title: "Rosie Hutin ghton Habits Career.", image: "/assets/img/news/news283.jpg" },
//                 { title: "Someone Has Cal The Total Cost", image: "/assets/img/news/news284.jpg" },
//                 { title: "Rosie Hutin ghton Habits Career.", image: "/assets/img/news/news285.jpg" },
//                 { title: "Rosie Hutin ghton Habits Career.", image: "/assets/img/news/news282.jpg" },
//                 { title: "Rosie Hutin ghton Habits Career.", image: "/assets/img/news/news286.jpg" },
//                 { title: "Rosie Hutin ghton Habits Career.", image: "/assets/img/news/news287.jpg" }
//             ]
//         }
//     };

//     useEffect(() => {
//         let mounted = true;
//         const fetchData = async () => {
//             try {
//                 setLoading(true);
//                 setError(null);
//                 const res = await axios.get(`${process.env.REACT_APP_BASE_URL}api/v1/users/politics/all`);
//                 console.log("res: politics : ", res, res.data);
//                 if (!mounted) return;
//                 const fetchedData = res.data.data[0] || defaultData;
//                 setData(fetchedData);
//             } catch (err) {
//                 console.error("Error fetching data:", err);
//                 setError("Failed to load data. Showing default content.");
//                 setData(defaultData);
//             } finally {
//                 if (mounted) setLoading(false);
//             }
//         };

//         // Only fetch if no props data is provided
//         if (homePolitics.length === 0) {
//             fetchData();
//         } else {
//             setLoading(false); // If props are provided, no need to load
//         }

//         return () => {
//             mounted = false;
//         };
//     }, [homePolitics.length]); // Depend on props to refetch if needed

//     // If props.data is provided, map it to the expected structure
//     const mapPropsDataToStructure = (propsData) => {
//         if (!propsData || propsData.length === 0) return defaultData;

//         const section = propsData[0];
//         const mainNews = section.mainNews || {};
//         const subNews = section.subNews || [];
//         const recentNews = section.recentNews || [];

//         // Map mainNews to main_news.featured
//         const featured = {
//             title: section.sectionTitle || "राजनीति की ताज़ा खबरें",
//             category: mainNews.category || "News",
//             date: mainNews.date || "2017-03-22T17:49",
//             image: mainNews.imageUrl || "/assets/img/ezgif-5530dd1da8b37c_1759988348.webp"
//         };

//         // Map subNews to main_news.list
//         const list = subNews.map(item => ({
//             title: item.title?.[0] || "No Title",
//             image: item.imageUrl?.[0] || "/assets/img/live-update-centre-2025-10-09t081936484_1759978108.webp",
//             category: "News", // No category in data, default to News
//             date: item.date?.[0] || "2017-03-22T17:50",
//             description: item.description?.[0] || ""
//         }));

//         // Map recentNews to sidebar.recent_news
//         const recent_news = recentNews.map(item => ({
//             title: item.title?.[0] || "No Title",
//             image: item.imageUrl?.[0] || "/assets/img/news/news283.jpg"
//         }));

//         return {
//             main_news: {
//                 featured,
//                 list
//             },
//             sidebar: {
//                 ...defaultData.sidebar,
//                 recent_news
//             }
//         };
//     };

//     // Use props data if available, otherwise use fetched or default
//     const finalData = homePolitics.length > 0 ? mapPropsDataToStructure(homePolitics) : data;

//     if (loading) {
//         return (
//             <section className="section-space-bottom-less30">
//                 <div className="container">
//                     <div className="row">
//                         <div className="col-12 text-center">
//                             <div className="spinner-border" role="status">
//                                 <span className="sr-only">Loading...</span>
//                             </div>
//                             <p>Loading politics news...</p>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         );
//     }

//     if (error) {
//         console.warn(error);
//         // Still render with default data, but could show error message
//     }

//     return (
//         <>
//             <section className="section-space-bottom-less30">
//                 <div className="container">
//                     <div className="row">
//                         <div className="col-lg-8 col-md-12 mb-30">
//                             <div className="topic-border color-cod-gray mb-30">
//                                 <div className="topic-box-lg color-cod-gray">{finalData.main_news?.featured?.title}</div>
//                             </div>
//                             <div className="img-overlay-70 img-scale-animate">
//                                 <img 
//                                     src={finalData.main_news?.featured?.image} 
//                                     alt="news" 
//                                     className="img-fluid" 
//                                     style={{ height: '400px', objectFit: 'cover' }} // Fixed height and object-fit for uniform size
//                                 />
//                                 <div className="mask-content-lg">
//                                     <div className="topic-box-sm color-cod-gray mb-20 hidden-mb">National News</div>
//                                     <div className="post-date-light">
//                                         <ul>
//                                             <li>
//                                                 <span>
//                                                     <i className="fa fa-calendar" style={{ color: "black" }} aria-hidden="true" />
//                                                 </span>{new Date(finalData.main_news?.featured?.date).toLocaleDateString()}
//                                             </li>
//                                         </ul>
//                                     </div>
//                                     <h2 className="title-medium-light size-xl d-none d-sm-block">
//                                         <Link to="/news-info">{finalData.main_news?.featured?.category}</Link>
//                                     </h2>
//                                 </div>
//                             </div>
//                             <div className="item-box-light-md-less30 ie-full-width">
//                                 {finalData.main_news?.list?.map((item, index) => (
//                                     <div key={index} className="media mb-30 media-none--sm">
//                                         <div className="position-relative width-40">
//                                             <Link to="/news-info" className="img-opacity-hover">
//                                                 <img 
//                                                     src={item.image} 
//                                                     alt="news" 
//                                                     className="img-fluid" 
//                                                     style={{ height: '200px', objectFit: 'cover' }} // Fixed height and object-fit for uniform size
//                                                 />
//                                             </Link>
//                                             <div className="topic-box-top-xs">
//                                                 <div className="topic-box-sm color-cod-gray mb-20">{item.category}</div>
//                                             </div>
//                                         </div>
//                                         <div className="media-body p-mb-none-child media-margin30">
//                                             <div className="post-date-dark">
//                                                 <ul>
//                                                     <li>
//                                                         <span>
//                                                             <i className="fa fa-calendar" style={{ color: "black" }} aria-hidden="true" />
//                                                         </span>{new Date(item.date).toLocaleDateString()}
//                                                     </li>
//                                                 </ul>
//                                             </div>
//                                             <h3 className="title-semibold-dark size-lg mb-15 mb5-md">
//                                                 <Link to="/news-info">{item.title}</Link>
//                                             </h3>
//                                             <p>{item.description}</p>
//                                         </div>
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>
//                         <div className="ne-sidebar sidebar-break-md col-lg-4 col-md-12">
//                             <div className="sidebar-box">
//                                 <div className="topic-border color-cod-gray mb-30">
//                                     <div className="topic-box-lg color-cod-gray">Stay Connected</div>
//                                 </div>
//                                 <ul className="stay-connected-light overflow-hidden mb-20">
//                                     {finalData.sidebar?.social_links?.map((link, index) => (
//                                         <li key={index} className={link.platform}>
//                                             <Link to="#">
//                                                 {link.icon.startsWith('http') || link.icon.startsWith('/') ? (
//                                                     <img src={link.icon} alt={link.platform} style={{ width: '20px', height: '20px' }} />
//                                                 ) : (
//                                                     <i className={link.icon} aria-hidden="true" />
//                                                 )}
//                                                 <div className="connection-quantity">{link.follows}</div>
//                                             </Link>
//                                         </li>
//                                     ))}
//                                 </ul>
//                             </div>
//                             <div className="sidebar-box">
//                                 <div className="topic-border color-cod-gray">
//                                     <div className="topic-box-lg color-cod-gray">Weather</div>
//                                 </div>
//                                 <br />
//                                 <div className="img-overlay-70 img-scale-animate">
//                                     <img 
//                                         src={finalData.sidebar?.weather?.image} 
//                                         alt="news" 
//                                         className="img-fluid" 
//                                         style={{ height: '200px', objectFit: 'cover' }} // Fixed height and object-fit for uniform size
//                                     />
//                                     <div className="mask-content-lg">
//                                         <div className="topic-box-sm color-cod-gray mb-20 hidden-mb">{finalData.sidebar?.weather?.location}</div>
//                                         <div className="post-date-light">
//                                             <ul>
//                                                 <li style={{ fontSize: "18px" }}>
//                                                     <span>
//                                                         <i className="fa fa-clock-o" aria-hidden="true" />
//                                                     </span>{finalData.sidebar?.weather?.time}
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                         <h2 className="title-medium-light size-xl d-none d-sm-block">
//                                             <p>{finalData.sidebar?.weather?.condition}</p>
//                                         </h2>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="sidebar-box">
//                                 <div className="topic-border color-cod-gray">
//                                     <div className="topic-box-lg color-cod-gray">Recent News</div>
//                                 </div>
//                                 <div className="row">
//                                     {finalData.sidebar?.recent_news?.map((news, index) => (
//                                         <div key={index} className="col-lg-6 col-md-4 col-sm-6 col-6 mt-30">
//                                             <div className="item-shadow-gray">
//                                                 <div className="position-relative">
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">News</div>
//                                                     </div>
//                                                     <Link to="/news-info" className="img-opacity-hover">
//                                                         <img 
//                                                             src={news.image} 
//                                                             alt="news" 
//                                                             className="img-fluid" 
//                                                             style={{ height: '150px', objectFit: 'cover' }} // Fixed height and object-fit for uniform size
//                                                         />
//                                                     </Link>
//                                                 </div>
//                                                 <div className="box-padding15 bg-body item-shadow-gray">
//                                                     <h3 className="title-medium-dark size-sm mb-10">
//                                                         <Link to="/news-info">{news.title}</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </>
//     );
// };

// export default HomePolitics;











import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const HomePolitics = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  // ---------- DEFAULT STATIC DATA ----------
  const defaultData = {
    main_news: {
      featured: {
        title: "राजनीति की ताज़ा खबरें",
        category:
          "यमुनोत्री जाते समय चलती कार में गिरा पहाड़: 3 लोग सवार...",
        date: "2017-03-22T17:49",
        // image: "/assets/img/ezgif-5530dd1da8b37c_1759988348.webp",
        image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766689123/ezgif-5530dd1da8b37c_1759988348_zs5bii.webp"
      },

      list: [
        {
          title:
            "जहरीला कफ सिरप बनाने वाली कंपनी का डायरेक्टर गिरफ्तार – Madhya Pradesh",
          // image:
          //   "/assets/img/live-update-centre-2025-10-09t081936484_1759978108.webp",
          image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688154/live-update-centre-2025-10-09t081936484_1759978108_amjvky.webp",
          category: "News",
          date: "2017-03-22T17:50",
          description:
            "मध्य प्रदेश में 23 बच्चों की मौत का कारण बने कोल्ड्रिफ कफ सिरप बनाने वाली कंपनी...",
        },
        {
          title:
            "हरियाणा IPS सुसाइड केस; 2 धड़ों में बंटे अफसर – Chandigarh News",
          // image: "/assets/img/ezgif-25eec5267e400a_1759978236.webp",
          image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688163/ezgif-25eec5267e400a_1759978236_l0w35c.webp",
          category: "News",
          date: "2017-03-22T02:34",
          description:
            "हरियाणा के IPS अफसर IG वाई पूरन कुमार का सुसाइड केस तूल पकड़ता दिख रहा है...",
        },
        {
          title:
            "नागपुर से मिला था छिंदवाड़ा को ‘मौत का अलर्ट’ – Madhya Pradesh News",
          // image: "/assets/img/11-1_1759952360.webp",
          image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688163/11-1_1759952360_dcagf4.webp",
          category: "News",
          date: "2017-03-22T02:34",
          description:
            "छिंदवाड़ा में कोल्ड्रिफ कफ सिरप से हुई मौतों को टाला जा सकता था...",
        },
      ],
    },
  };

  // ---------- FETCH DATA ----------
  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}api/v1/users/politics/all`
        );

        if (!mounted) return;

        const fetchedData = res?.data?.data?.[0] || defaultData;
        setData(fetchedData);
      } catch (err) {
        console.log("Political fetch error:", err);
        setData(defaultData);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchData();
    return () => (mounted = false);
  }, []);

  if (loading) return <div>Loading...</div>;

  const featured = data.main_news?.featured;
  const list = data.main_news?.list || [];

  return (
    <section className="section-space-bottom-less30 mt-lg-5">
      <div className="container">
        {/* ---------- SECTION TITLE ---------- */}
        <div className="topic-border color-cod-gray mb-30">
          <div className="topic-box-lg color-cod-gray">{featured?.title}</div>
        </div>

        {/* ---------- FEATURED POLITICS NEWS ---------- */}
        <div className="featured-news-card mb-5">
          <img
            src={
              Array.isArray(featured?.image)
                ? featured.image[0]
                : featured?.image
            }
            alt="featured"
            className="featured-image"
            onError={(e) => (e.target.src = "/assets/img/placeholder.jpg")}
          />

          <div className="featured-overlay">
            <span className="cat-badge">{featured?.title}</span>

            <h1 className="featured-title">
              <Link to="/news-info">{featured?.category}</Link>
            </h1>

            <p className="featured-date" style={{ color: "white", fontSize: "16px", fontFamily: "sans-serif" }}>
              <i className="fa fa-calendar" style={{ color: "white", margin: "10px" }}></i>{" "}
              {new Date(featured?.date).toLocaleDateString("hi-IN")}

              <i className="fa fa-share-alt" style={{ fontSize: "25px", color: "white", margin: "10px" }} />
              <i className="fa fa-thumbs-o-up" style={{ fontSize: "25px", color: "white", margin: "10px" }} />
              <i className="fa fa-commenting-o" style={{ fontSize: "25px", color: "white", margin: "10px" }} />

            </p>
          </div>
        </div>

        {/* ---------- POLITICS NEWS LIST ---------- */}
        <div className="row" style={{marginTop:"40px"}}>
          {list.map((item, index) => (
            <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
              <div className="news-card">
                <Link to="/news-info">
                  <img
                    src={Array.isArray(item.image) ? item.image[0] : item.image}
                    alt="news"
                    className="news-img"
                    onError={(e) =>
                      (e.target.src = "/assets/img/placeholder.jpg")
                    }
                  />
                </Link>

                <div className="news-content">
                  <span className="news-cat">{item.category}</span>

                  <h3 className="news-title">
                    <Link to="/news-info">{item.title}</Link>
                  </h3>

                  <p className="news-desc">{item.description}</p>

                  <p className="news-date" style={{ color: "black", fontSize: "16px", fontFamily: "sans-serif" }}>
                    <i className="fa fa-calendar" style={{ color: "black", margin: "10px" }}></i>{" "}
                    {new Date(item.date).toLocaleDateString("hi-IN")}

                    <i className="fa fa-share-alt" style={{ fontSize: "25px", color: "black", margin: "10px" }} />
                    <i className="fa fa-thumbs-o-up" style={{ fontSize: "25px", color: "black", margin: "10px" }} />
                    <i className="fa fa-commenting-o" style={{ fontSize: "25px", color: "black", margin: "10px" }} />

                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomePolitics;



